import React from "react";
import RegistroEspecialLiveViews from "views/registro-views/registro-especial-live";
import Footer from "components/layout-components/Footer";

const RegistroEspecialLiveLayout = (props) => {
	const { direction } = props;
	return (
		<div
			className={`app-layout-blank ${
				direction === "rtl" ? "ant-rtl" : ""
			}`}
		>
			<div className="container d-flex flex-column justify-content-center min-vh-100">
				<div className="d-flex justify-content-center mt-4 mb-4">
					<div className="registro-layout-content px-4">
						<RegistroEspecialLiveViews />
					</div>
				</div>
				<Footer className="justify-content-center" />
			</div>
		</div>
	);
};

export default RegistroEspecialLiveLayout;
